var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPin = function SvgIconPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-pin_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.6.5h24v24H.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-pin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.6 12.5c.55 0 1.02-.2 1.4-.59q.6-.585.6-1.41T14 9.09c-.38-.4-.85-.59-1.4-.59s-1.03.2-1.42.59-.58.86-.58 1.41.2 1.02.58 1.41c.4.4.87.59 1.42.59m0 7.35a27.5 27.5 0 0 0 4.52-5.09c.98-1.52 1.48-2.88 1.48-4.06 0-1.82-.58-3.3-1.74-4.46A5.8 5.8 0 0 0 12.6 4.5a5.8 5.8 0 0 0-4.27 1.74A6.04 6.04 0 0 0 6.6 10.7c0 1.18.49 2.54 1.47 4.06.98 1.53 2.5 3.22 4.53 5.09m0 2.65a33.2 33.2 0 0 1-6.02-6.36C5.26 14.18 4.6 12.37 4.6 10.7c0-2.5.8-4.5 2.4-5.97a8 8 0 0 1 5.6-2.23 8 8 0 0 1 5.58 2.22C19.8 6.21 20.6 8.2 20.6 10.7c0 1.67-.67 3.48-2 5.44a33.2 33.2 0 0 1-6 6.36"
  }))));
};
export default SvgIconPin;